import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Box } from 'grommet/components/Box';
import { Text } from 'grommet/components/Text';
import { Anchor } from 'grommet';

/*class Error extends React.Component {

    render() {

        return (

            <Box>
                {this.props.testo ? <Text className='error'>{this.props.testo}</Text> : <Text className='errorhide2'></Text>}
            </Box>
        );
    }
}*/


class Setting extends Component {
    static propTypes = {
        match: PropTypes.object,
        location: PropTypes.object,
        history: PropTypes.object
    }
    constructor(props) {
        super(props);
        this.state = {
            oldpwd: '',
            newpwd: '',
            confirmpwd: '',
            email: '',
            isAutenticated: false
        }
        this.setSearch = this.setSearch.bind(this);

    }


    setSearch(event) {
        if (event.target.id === 'oldpwd') {
            this.setState({
                oldpwd: event.target.value
            })
        } else if (event.target.id === 'newpwd') {
            this.setState({
                newpwd: event.target.value
            })
        } else if (event.target.id === 'confirmpwd') {
            this.setState({
                confirmpwd: event.target.value
            })
        } else if (event.target.id === 'email') {
            this.setState({
                email: event.target.value
            })
        }
    }


    render() {
        /*const enabled = !this.state.oldpwd || !this.state.newpwd || !this.state.confirmpwd || !this.state.email;*/

        return (
            <Box>

                <Box align='center' className='content' style={{ backgroundColor: '#f9f9f9', marginTop: '0' }}>

                    <Box className='contentbox' basis='medium' margin='small'>
                        <Box pad='medium' align='start' style={{ paddingBottom: '50px' }}>
                            <Text className='titlehome'><h1>Impostazioni</h1></Text>
                            <Text style={{ textAlign:'left' }}><h5>Desideri modificare la password, l'e-mail o il numero di telefono cellulare?</h5></Text>
                        </Box>

                        <Box align='center' margin='medium'>
                            <Box direction='column' gap='small' >

                                <Box align='center'>
                                    <Anchor className='link' style={{ marginBottom: '20px', width: '200px' }} href='/Setting/ModificaPassword'>MODIFICA PASSWORD</Anchor>
                                </Box>
                                <Box align='center' >
                                    <Anchor className='link' style={{ marginBottom: '20px', width: '200px' }} href='/Setting/ModificaEmail' disabled={this.state.isAutenticated}>MODIFICA EMAIL</Anchor>
                                </Box>
                                <Box align='center'>
                                    <Anchor className='link' style={{ marginBottom: '20px', width: '200px' }} href='/Setting/ModificaTelefono'>MODIFICA TELEFONO CELLULARE</Anchor>
                                </Box>
                                {/*
                                    this.state.isAutenticated ? '' : <Box align='center'>
                                    <Anchor className='link' style={{ marginBottom: '20px', width: '200px' }} href='/Setting/CertificaEmail'>CERTIFICA EMAIL</Anchor>
                                </Box>
                            */}

                            </Box>
                        </Box>

                    </Box>

                </Box>

            </Box>
        )
    }
}
export default Setting;